import { updatesData } from '@/mocks/homeData';

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="w-full max-w-[800px] mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 text-center mb-4">
          最新更新快讯
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-8">
          热门漫画每日极速更新，第一时间追更不等待
        </p>
        <div className="relative">
          <div className="absolute left-4 md:left-5 top-2 bottom-2 w-px bg-background-300"></div>
          <div className="flex flex-col gap-0">
            {updatesData.map((u, i) => (
              <div key={i} className="relative flex items-start gap-4 md:gap-5 pl-10 md:pl-12 py-4">
                <div className="absolute left-[13px] md:left-[16px] top-5 w-2.5 h-2.5 rounded-full bg-primary-500 ring-4 ring-background-50 z-10"></div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 flex-wrap mb-1">
                    <h3 className="font-heading text-sm text-foreground-900">
                      {u.title}
                    </h3>
                    {u.tag === '热门' ? (
                      <span className="px-1.5 py-0.5 bg-accent-100 text-accent-700 text-xs rounded font-medium">
                        热门
                      </span>
                    ) : (
                      <span className="px-1.5 py-0.5 bg-primary-100 text-primary-700 text-xs rounded font-medium">
                        新更
                      </span>
                    )}
                  </div>
                  <p className="text-xs text-foreground-600 mb-1">{u.description}</p>
                  <span className="text-xs text-foreground-400">{u.time}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}